export const LOAD_WON_TENDERS_TABLE_DATA = 'LOAD_WON_TENDERS_TABLE_DATA'
export const LOAD_WON_TENDERS_TABLE_DATA_REQUEST = (id) => `LOAD_WON_TENDERS_TABLE_${id}_DATA_REQUEST`
export const WON_TENDERS_TABLE_LOADING_TRUE = 'WON_TENDERS_TABLE_LOADING_TRUE'
export const WON_TENDERS_TABLE_LOADING_FALSE = 'WON_TENDERS_TABLE_LOADING_FALSE'
export const WON_TENDERS_TABLE_LOADING_FAILED = 'WON_TENDERS_TABLE_LOADING_FAILED'
export const WON_TENDERS_TABLE_DATA_RECEIVED = 'WON_TENDERS_TABLE_DATA_RECEIVED'
